import { useMemo } from 'react';
import { useAuth } from 'app/auth/hooks/useAuth';
import { DOCUMENTS_QUERY_KEY, DOCUMENTS_UNOPENED_FILTER } from '../constants';
import type { TAppointmentReport, TTelemonitoringReport, TUseUnopenedReportsResult } from '../types';
import { buildPagedQuery } from '../utils/documentsQuery';
import { useAllPages } from './useAllPages';

export const useUnopenedReports = (): TUseUnopenedReportsResult => {
    const { meData } = useAuth();
    const enabled = !!meData?.current_pathway?.id;

    const telemonitoring = useAllPages<TTelemonitoringReport>({
        buildUrl: perPage => `?${buildPagedQuery(DOCUMENTS_UNOPENED_FILTER.telemonitoringReports, perPage)}`,
        queryKey: [...DOCUMENTS_QUERY_KEY.unopenedTelemonitoringReports],
        resource: { name: 'telemonitoring-reports' },
        enabled,
    });

    const appointments = useAllPages<TAppointmentReport>({
        buildUrl: perPage => `?${buildPagedQuery(DOCUMENTS_UNOPENED_FILTER.appointmentReports, perPage)}`,
        queryKey: [...DOCUMENTS_QUERY_KEY.unopenedAppointmentReports],
        resource: { name: 'appointment-reports' },
        enabled,
    });

    return useMemo(() => {
        const telemonitoringIds = new Set(telemonitoring.items.map(report => report.id));
        const appointmentIds = new Set(appointments.items.map(report => report.id));
        return {
            telemonitoringIds,
            appointmentIds,
            count: telemonitoringIds.size + appointmentIds.size,
        };
    }, [telemonitoring.items, appointments.items]);
};
